/** Client-side view of the signed-in user, mirroring `GET /api/me`. */

export type Role = "admin" | "product_owner" | "developer" | "viewer";

export type SessionUser = {
  id: string;
  name: string | null;
  email: string | null;
  avatarUrl: string | null;
  role: Role;
  status: string;
};

export const ROLE_LABELS: Record<Role, string> = {
  admin: "Admin",
  product_owner: "Product Owner",
  developer: "Developer",
  viewer: "Viewer",
};

/** Returns the current user, or null when not authenticated (401). */
export async function fetchSession(): Promise<SessionUser | null> {
  const res = await fetch("/api/me", {
    headers: { Accept: "application/json" },
  });
  if (!res.ok) return null;
  const data = (await res.json()) as { user: SessionUser | null };
  return data.user;
}

export async function logout(): Promise<void> {
  await fetch("/auth/logout", { method: "POST" });
}
